import React from 'react';
import { Controller } from 'react-hook-form';
import { FormFeedback, Input } from 'reactstrap';
import { CLAIM_FORM_TYPES } from '../../../pages/ExpenseClaims/Employee/EmployeeExpenseClaim/constants';

export default function InputElement({
  formMethods,
  name,
  type = 'text',
  formType,
  config = {},
}) {
  const {
    control,
    formState: { errors },
  } = formMethods;

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            type={type}
            name={name}
            className={`form-control external-filter-input ${errors?.[name] ? 'is-invalid' : ''}`}
            disabled={formType === CLAIM_FORM_TYPES.VIEW}
            placeholder={config?.placeholder || ''}
          />
        )}
      />
      {errors?.[name] && <FormFeedback>{errors?.[name]?.message}</FormFeedback>}
    </>
  );
}
